import React from 'react';
import SubmitResultsPage from '../submitResults/SubmitResultsPage';

const ResultSubmission = ({ projectId }) => {
  return <SubmitResultsPage projectId={projectId} />;
};

export default ResultSubmission;

